import { render, staticRenderFns } from "./TableBasic.vue?vue&type=template&id=772776be&"
import script from "./TableBasic.vue?vue&type=script&lang=js&"
export * from "./TableBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports